export default __webpack_public_path__ + "static/media/warning.dcb61c34.svg";